import { render, staticRenderFns } from "./configureReviewersCustom.vue?vue&type=template&id=5a853e98&"
import script from "./configureReviewersCustom.vue?vue&type=script&lang=ts&"
export * from "./configureReviewersCustom.vue?vue&type=script&lang=ts&"
import style0 from "./configureReviewersCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports